import { logger } from 'affiny-core/logger';
import {
  IFormattedApiError,
  IPaymentError,
} from 'affiny-core/modules/api/core/types';
import { EAsyncEventTypes } from 'affiny-core/modules/asynchronousState/types';
import { i18n } from 'affiny-core/translations';
import { HTTP_STATUS } from '../AsyncStatusHandler';

export enum EErrorType {
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  NO_CONFIGURATION = 'NO_CONFIGURATION',
  CAPTCHA_NOT_RECEIVED = 'CAPTCHA_TOKEN_NOT_RECEIVED',
  API_ERROR = 'ERRORS/API',
  UNKNOWN_ERROR = 'ERRORS/UNKNOWN',
  NO_NETWORK_ERROR = 'ERRORS/NO_NETWORK',
  // TODO remove custom error
  CUSTOM_ERROR = 'ERRORS/CUSTOM',
  SILENT_ERROR = 'SILENT/ERRORS',
  PAYMENT_ERROR = 'ERRORS/PAYMENT',
}

const noToasterErrorCode: number[] = [
  HTTP_STATUS.PAYMENT_REQUIRED,
  HTTP_STATUS.LOCKED,
  HTTP_STATUS.NOT_ACCEPTABLE,
];

export const computeErrorCode = (
  error: IFormattedApiError,
  asyncEventName?: EAsyncEventTypes
) => {
  if (!error.status) {
    logger.logWithMessageAndData(`Unknwon error in ${asyncEventName}`, error);

    return EErrorType.UNKNOWN_ERROR;
  }

  if (noToasterErrorCode.includes(error.status)) return;

  switch (error.status) {
    case HTTP_STATUS.BAD_REQUEST:
      return error.code === EErrorType.CAPTCHA_NOT_RECEIVED
        ? EErrorType.NO_CONFIGURATION
        : EErrorType.API_ERROR;

    case HTTP_STATUS.UNAUTHORIZED:
      return error.code === EErrorType.INVALID_CREDENTIALS
        ? EErrorType.INVALID_CREDENTIALS
        : EErrorType.API_ERROR;

    case HTTP_STATUS.PAYMENT_REQUIRED:
      return undefined;

    case HTTP_STATUS.UNPROCESSABLE_ENTITY:
      return asyncEventName === EAsyncEventTypes.CHANGE_PASSWORD ||
        (asyncEventName?.startsWith(EAsyncEventTypes.REGISTER) &&
          i18n.checkExist('errors.' + error.code))
        ? error.code
        : EErrorType.API_ERROR;

    default:
      return EErrorType.API_ERROR;
  }
};

export const getPaymentErrorMessage = (error: IPaymentError) =>
  error.errorCodeType
    ? `${EErrorType.PAYMENT_ERROR}/${error.errorCodeType}`
    : EErrorType.UNKNOWN_ERROR;
